import { t } from 'ember-intl';
import eq from 'ember-truth-helpers/helpers/eq';
import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';
import BvBtn from 'volta/components/bv-btn';
import isPresent from 'volta/helpers/is-present';

import type { TOC } from '@ember/component/template-only';
import type { TForecastProjectStatus } from 'volta/models/types/forecast-projects';

const ForecastProjectTitle: TOC<{
  Args: {
    forecastProject: {
      fpHeaderId: string;
      name: string;
      revision?: string;
      revisionNumber: number;
      description?: string;
      status: TForecastProjectStatus;
    };
  };
  Element: HTMLDivElement;
}> = <template>
  <BvInline @wrap={{false}} @gap='2' @blockAlign='center' class='u-ellipsis' ...attributes>
    <BvBtn
      @route='protected.forecast-project'
      @routeModel={{@forecastProject.fpHeaderId}}
      @plain={{true}}
    >
      <BvText @text={{@forecastProject.name}} @fontWeight='semibold' class='u-ellipsis' />
    </BvBtn>
    <BvText @text='•' @fontWeight='semibold' @color='subdued' />
    {{#if (isPresent @forecastProject.revision)}}
      <BvText @text={{@forecastProject.revision}} @fontWeight='semibold' @color='subdued' />
    {{else if (eq @forecastProject.revisionNumber 0)}}
      <BvText
        @text={{t 'forecastProjectPage.projectModel'}}
        @fontWeight='semibold'
        @color='subdued'
      />
    {{else}}
      <BvText
        @text={{t
          'forecastProjectPage.projectRevision'
          revisionNumber=@forecastProject.revisionNumber
        }}
        @fontWeight='semibold'
        @color='subdued'
      />
    {{/if}}
  </BvInline>
</template>;

export default ForecastProjectTitle;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ForecastProject::ForecastProjectTitle': typeof ForecastProjectTitle;
    'forecast-project/forecast-project-title': typeof ForecastProjectTitle;
  }
}
